<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>group</md-icon>
          </div>
          <h4 class="title">Parents</h4>
        </md-card-header>
        <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-size-30">
                <md-field>
                  <md-input type="text" class="box-textbox" placeholder="Search by email" v-model="email"></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-30">
                <md-field>
                  <md-input type="text" class="box-textbox" placeholder="Search by serial number" v-model="serialNumber"></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-25">
                  <md-button class="md-primary" :disabled="isDisabled" @click="deviceAllocationList()">
                    Search
                    <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
                  </md-button> 
              </div>
          </div>
          <hr>
          <md-table
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="paginated-table table-striped table-hover"
          >
            <md-table-toolbar>
              <md-field>
                <label for="pages">Per page</label>
                <md-select v-model="pagination.perPage" name="pages">
                  <md-option
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Serial Number" md-sort-by="serialNumber">{{ item.serialNumber }}</md-table-cell>
                <md-table-cell md-label="Kid Name" md-sort-by="profileName">{{ item.profileName }}</md-table-cell>
                <md-table-cell md-label="Parent" md-sort-by="email">{{ item.email }}</md-table-cell>
                <md-table-cell md-label="Enrollment At" md-sort-by="enrollmentTime">{{ HumanReadableDateFormat(item.enrollmentTime, true) }}</md-table-cell>                
                <md-table-cell md-label="Created At" md-sort-by="createdAt">{{ HumanReadableDateFormat(item.createdAt, true) }}</md-table-cell>                
                <md-table-cell md-label="Actions">
                    <button type="button" class="btn btn-danger btn-sm mr-1" :disabled="isDisabled" @click="deleteDevice(item.name, item.email)"><i class="fas fa-trash-alt"></i> Device</button>
                    <button type="button" :disabled="isDisabled" class="btn btn-danger btn-sm" @click="deleteProfile(item.profileId, item.email)"><i class="fas fa-trash-alt"></i> Profile</button>
                </md-table-cell>
            </md-table-row>

          </md-table>
          
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class="">
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          >
          </pagination>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import { Pagination } from "@/components";
import Swal from "sweetalert2";
import DeviceDataService from "../../services/SuperAdmin/DeviceDataService";
import DeviceProceDataService from "../../services/DeviceProceDataService";


export default {
  components: {
    Pagination,
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  data() {
    return {
      isDisabled: false,
      currentSort: "createdAt",
      currentSortOrder: "asc",
      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      tableData: [],
      searchedData: [],
      serialNumber:"",
      email:"",
      
    };
  },
  methods: {
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
    deviceAllocationList() {
        this.isDisabled = true;
        let data = { email: this.email, serialNumber: this.serialNumber };
        DeviceDataService.deviceAllocationList(data)
          .then((response) => {
            this.isDisabled = false;
            this.tableData = response.data.data;
          })
          .catch((e) => {
            this.isDisabled = false;
            this.$toast.error(e.response.data.respones_msg);
          });
    },
    deleteProfile(profile_id, email) {
      Swal.fire({
        title: "Are you sure?",
        text: `All devices in this profile will be factory reseted`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          var data = {
            profile_id : profile_id,
            email: email
          };
          DeviceDataService.deleteProfile(data)
          .then((response) => {
            this.$toast.success(response.data.respones_msg);
            this.deviceAllocationList();
            this.isDisabled = false;
          })
          .catch((e) => {
            this.$toast.error(e.response.data.respones_msg);
            this.deviceAllocationList();
            this.isDisabled = false;
          });
        }
      });  
    },
    deleteDevice(name, email) {
        Swal.fire({
        title: "Are you sure?",
        text: `Are you sure you wont to delete this device?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
            let data = {
                name: name,
                email: email,
            } 
            DeviceDataService.deleteDevice(data)
            .then((response) => {
                this.$toast.success(response.data.respones_msg);
                this.deviceAllocationList();
            }).catch((e) => {
                this.$toast.error(e.response.data.respones_msg);
            });
        }
      });
    },
  },
  beforeMount() {
  },
  mounted() {
  },
  watch: {
  },
};
</script>

<style scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
::v-deep .md-table-cell {
  word-wrap: break-word;
  white-space: normal;
  vertical-align: top;
}

::v-deep .md-table-cell[md-label="Email"],
::v-deep .md-table-cell[md-label="Order Status"] {
  min-width: 160px;
}
</style>
